var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgOlxPro = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M16.733 34.468a7.321 7.321 0 0 1 7.32-7.321h49.784a7.321 7.321 0 0 1 7.321 7.321H16.733Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M16.733 34.467h64.426V66.68H16.733z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M48.58 27.51h26.734c3.254 0 5.845 2.602 5.845 5.873v34.203"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M49.677 27.51H22.943c-3.255 0-5.845 2.602-5.845 5.873v34.203M47.48 31.188h2.196M17.83 34.866h63.328"
  }), React.createElement("path", {
    fill: borderColor,
    d: "M33.774 55.923c2.154 0 3.866-1.765 3.866-4.147 0-2.354-1.618-4.133-3.866-4.133-2.153 0-3.866 1.766-3.866 4.147 0 2.394 1.62 4.133 3.866 4.133Zm0-1.779c-1.163 0-1.966-.95-1.966-2.354 0-1.418.803-2.368 1.966-2.368 1.164 0 1.967.95 1.967 2.355 0 1.417-.803 2.367-1.967 2.367ZM39.232 52.766h3.693c.254 0 .401-.147.401-.401V51.2c0-.254-.147-.402-.401-.402H40.45V45.85c0-.254-.147-.401-.401-.401H38.83c-.254 0-.401.147-.401.401v6.114c0 .522.28.802.802.802Z"
  }), React.createElement("path", {
    fill: borderColor,
    d: "m44.249 55.803 2.22-2.556 2.154 2.556c.188.227.428.227.642.04l.87-.763c.214-.187.24-.428.04-.642l-2.394-2.675 2.18-2.448c.187-.214.174-.442-.04-.643l-.816-.735c-.214-.201-.455-.188-.642.04L46.47 50.29l-2.034-2.314c-.187-.214-.428-.241-.642-.04l-.842.75c-.215.2-.228.414-.027.642l2.22 2.447-2.42 2.69c-.202.227-.175.454.04.641l.842.736c.214.187.455.174.642-.04ZM53.243 56.323v-6.857h.542v.62c.404-.452.996-.718 1.646-.718.542 0 1.054.197 1.428.502.513.434.838 1.094.838 1.843 0 .807-.364 1.507-.956 1.921a2.28 2.28 0 0 1-1.34.424c-.699 0-1.26-.305-1.596-.739v3.005h-.562Zm.561-3.783c.355.61.947.985 1.606.985.385 0 .73-.138 1.015-.335.434-.305.71-.856.71-1.477 0-.582-.237-1.104-.63-1.43a1.736 1.736 0 0 0-1.084-.384c-.828 0-1.419.572-1.616.907v1.734ZM61.213 49.91c-.059-.01-.236-.01-.266-.01-.61 0-1.172.414-1.409.995v3.064h-.561v-4.493h.562v.59c.207-.315.719-.689 1.418-.689.08 0 .276.01.335.02l-.079.522ZM64.198 54.057c-1.34 0-2.315-1.054-2.315-2.345 0-1.29.975-2.345 2.315-2.345 1.34 0 2.316 1.055 2.316 2.345 0 1.29-.975 2.345-2.316 2.345Zm0-4.158c-1.015 0-1.753.808-1.753 1.813 0 1.006.738 1.813 1.753 1.813s1.754-.807 1.754-1.813c0-1.005-.739-1.813-1.754-1.813Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M8.695 69.12c0-.934.757-1.691 1.69-1.691h77.116c.934 0 1.69.757 1.69 1.69a4.13 4.13 0 0 1-4.13 4.13H12.826a4.13 4.13 0 0 1-4.13-4.13Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M85.188 41.481h-12.68a2.456 2.456 0 0 0-2.445 2.468v8.182a2.456 2.456 0 0 0 2.445 2.468h1.545c.193 0 .322.13.322.324v3.182c0 .26.322.39.515.195l3.604-3.636c.064-.065.129-.065.193-.065h6.5a2.456 2.456 0 0 0 2.446-2.468v-8.182c0-1.429-1.094-2.468-2.445-2.468Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M83.239 46.63h-8.053M83.239 49.571h-5.125"
  }), React.createElement("rect", {
    width: 23.392,
    height: 22.66,
    x: 6.75,
    y: 22.75,
    fill: color,
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 3.25
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M21.496 28.498h2.44c.253 0 .458.204.458.457V39.93a.457.457 0 0 1-.457.457h-2.44a.457.457 0 0 1-.458-.457V28.955c0-.253.205-.457.457-.457Zm.459.913v10.061h1.525v-10.06h-1.525Zm-4.73 2.134h2.44c.254 0 .459.205.459.458v7.926a.457.457 0 0 1-.458.458h-2.44a.457.457 0 0 1-.458-.458v-7.926c0-.253.205-.458.457-.458Zm.457.915v7.012h1.525V32.46h-1.525Zm-4.727 2.134h2.44c.253 0 .458.204.458.457v4.878a.458.458 0 0 1-.457.457h-2.44a.457.457 0 0 1-.458-.457v-4.878c0-.253.204-.457.457-.457Zm.458.914v3.963h1.525v-3.963h-1.525Z",
    clipRule: "evenodd"
  }));
};
export default SvgOlxPro;